import PropTypes from 'prop-types';
import { Fragment, PureComponent } from 'react';
import styled from 'styled-components';

import { HorizontalList, VerticalList } from '~/components/Elements';
import { colors } from '~/utils/css-mixins';
import { money } from '~/utils/format';

import { findStartByRaceStartNumber } from '../utils';
import AtgForm from './AtgForm';
import Start from './Start';

const SideListWrapper = styled.div`
  font-size: 14px;
  line-height: 20px;
`;

const SystemWrapper = styled.div`
  margin-top: 1rem;

  &:first-child {
    margin-top: 0;
  }
`;

const SeparatedList = styled(HorizontalList)`
  display: inline;

  li:not(:last-child)::after {
    content: '${props => props.separator}';
  }
`;

const SystemDetails = styled.div`
  margin-top: 0.5rem;
`;

const Header = styled.h4`
  font-size: 16px;
  margin-bottom: 8px;
`;

const StakeTotal = styled.div`
  margin-top: 1rem;
  font-weight: 600;
`;

const Info = styled.div`
  color: ${colors.textmeta};
  font-size: 14px;
  font-style: italic;
  line-height: 20px;
  margin-top: 5px;
`;

class System extends PureComponent {
  static propTypes = {
    round: PropTypes.object.isRequired,
    system: PropTypes.object.isRequired,
  };

  getLeg(round, race_id, bet_type, index) {
    if (bet_type === 'DD') {
      return index + 1;
    } else if (bet_type === 'TV') {
      for (let i = 0; i < round.legs.length; i++) {
        if (round.legs[i].race === race_id) {
          return round.legs[i].leg;
        }
      }
    }

    return null;
  }

  render() {
    const { round, system } = this.props;
    const { stake, cost, data, atg_file, auto_updated } = system;
    const bet_type =
      system.bet_type === 'TV' ? round.bet_type : system.bet_type;
    const separator = system.bet_type === 'TV' ? ' - ' : ', ';

    return (
      <Fragment>
        {system.bet_type === 'TV' && (
          <VerticalList>
            {Object.keys(data)
              .map(race_id => Number.parseInt(race_id, 10))
              .map((race_id, i) => (
                <li key={race_id}>
                  <strong>
                    {bet_type}-{this.getLeg(round, race_id, system.bet_type, i)}
                    :{' '}
                  </strong>
                  <SeparatedList separator={separator}>
                    {data[race_id].regular.map((start_number, idx, arr) => (
                      <li key={start_number}>
                        <Start
                          start={findStartByRaceStartNumber(
                            round,
                            race_id,
                            start_number,
                          )}
                          showName={arr.length === 1}
                        />
                      </li>
                    ))}

                    {data[race_id].u_marks.length > 0 && (
                      <>
                        <strong>U-häst: </strong>
                        <Start
                          start={findStartByRaceStartNumber(
                            round,
                            race_id,
                            data[race_id].u_marks[0],
                          )}
                          showName
                        />
                      </>
                    )}
                  </SeparatedList>
                </li>
              ))}
          </VerticalList>
        )}

        {system.bet_type === 'DD' && (
          <VerticalList>
            {data.map((dd, i) => (
              <li key={dd.race_id}>
                <strong>
                  {bet_type}-
                  {this.getLeg(round, dd.race_id, system.bet_type, i)}:{' '}
                </strong>

                <SeparatedList separator={separator}>
                  {dd.regular.map((start_number, idx, arr) => (
                    <li key={start_number}>
                      <Start
                        start={findStartByRaceStartNumber(
                          round,
                          dd.race_id,
                          start_number,
                        )}
                        showName={arr.length === 1}
                      />
                    </li>
                  ))}
                </SeparatedList>
              </li>
            ))}
          </VerticalList>
        )}

        <SystemDetails>
          <div>Insats: {stake} kr</div>
          {system.bet_type === 'DD' && <div>Totalt: {cost / 100} kr</div>}
        </SystemDetails>

        {atg_file && (
          <SystemDetails>
            <AtgForm xml={atg_file} />
          </SystemDetails>
        )}

        {auto_updated && (
          <Info>
            OBS: På grund av strykning/strykningar har det ursprungliga systemet
            justerats.
          </Info>
        )}
      </Fragment>
    );
  }
}

export default class SideList extends PureComponent {
  static propTypes = {
    round: PropTypes.object.isRequired,
    systems: PropTypes.array.isRequired,
    bet_type: PropTypes.string.isRequired,
  };

  render() {
    const { round, systems, bet_type } = this.props;

    let total = 0;

    if (bet_type === 'DD') {
      systems.forEach(system => {
        total += system.cost;
      });
    }

    total /= 100;

    return (
      <SideListWrapper>
        <Fragment>
          {systems.map((system, i) => (
            <SystemWrapper key={i}>
              {system.bet_type === 'DD' && <Header>Kupong {i + 1}</Header>}
              <System round={round} system={system} />
            </SystemWrapper>
          ))}
        </Fragment>

        {systems.length > 1 && total > 0 && (
          <StakeTotal>Totalt: {money(total)}</StakeTotal>
        )}
      </SideListWrapper>
    );
  }
}
